const hasMenuAccess = (menuItem, accessRows = []) => accessRows.some((accessRow) =>
    accessRow.menuItemName?.trim() === menuItem.menuItemName?.trim() &&
    accessRow.menuAccess !== 0 &&
    accessRow.moduleorder === menuItem.moduleorder
);

export const hasMenuOrChildAccess = (menuItem, accessRows = []) =>
    hasMenuAccess(menuItem, accessRows) ||
    (menuItem.subLinks || []).some((child) => hasMenuAccess(child, accessRows));

export { hasMenuAccess };
